import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

export default function Page404() {
  const { t } = useTranslation();
  React.useEffect(() => {
    // For server-side rendering: set 404 status via custom mechanism
    if (typeof window === "undefined") {
      // set status (implementation depends on your SSR framework)
    }
  }, []);

  return (
    <div className="container">
      <h1 className="message">
        {t('US.COMMON:COMMON.404HTTPERROR')}
      </h1>
      <p className="details">
        {t('US.COMMON:COMMON.DETAIL')} :(
      </p>
    </div>
  );
}
